import { ref, get, database } from "../../firebase-config";

// const simulateError = true

export const fetchQuestions = async (psikotesId) => {
  try {
    // if (simulateError) {
    //    throw new Error("eror ges");
    //  }

    const psikotesRef = ref(database, `psikotest/${psikotesId}/questions`);
    const snapshot = await get(psikotesRef);

    if (snapshot.exists()) {
      const questionsData = snapshot.val();
      const validQuestionIds = Object.keys(questionsData).filter(
        (questionId) => questionsData[questionId]
      );

      const questionsPromises = validQuestionIds.map(async (questionId) => {
        const questionRef = ref(database, `questions/${questionId}`);
        const questionSnapshot = await get(questionRef);
        return questionSnapshot.exists() ? questionSnapshot.val() : {};
      });

      const fetchedQuestionsData = await Promise.all(questionsPromises);

      return fetchedQuestionsData.map((data) => ({
        statements: Object.keys(data.statements).map((key) => ({
          id: key,
          ...data.statements[key],
        })),
      }));
    } else {
      console.error("No questions found for this psikotes");
      return [];
    }
  } catch (error) {
    console.error("Error fetching questions:", error);
    return [];
  }
};

export const fetchResultsClient = async (psikotesId, user, resultId) => {
  try {
    const resultsRef = ref(
      database,
      `results/${psikotesId}/${user}/${resultId}`
    );
    const snapshot = await get(resultsRef);
    if (snapshot.exists()) {
      return snapshot.val();
    } else {
      console.log("No data available");
      return null;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchPersonality = async (personalityKey) => {
  try {
    const personalityRef = ref(database, `personalities/${personalityKey}`);
    const snapshot = await get(personalityRef);
    if (snapshot.exists()) {
      return snapshot.val();
    } else {
      console.log("No data available");
      return null;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
